import { useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { DockFooterSlotContext } from './dockSlots';
import './editor-dock.css';

/**
 * The dock's action row, pinned below the scrolling body. It can sit anywhere
 * inside an `EditorDock`, so a form keeps its actions next to its fields in the
 * source; give a submit button the form's `form` attribute, because the row
 * leaves the form's DOM. Outside a dock it renders in place. Buttons take the
 * `.pnid-btn` recipe.
 */
export default function DockFooter({ children }: { children: ReactNode }) {
  const slot = useContext(DockFooterSlotContext);
  const row = <div className="pnid-dock-footer">{children}</div>;
  if (slot === undefined) return row;
  return slot ? createPortal(row, slot) : null;
}
